

























































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, ID, success, error, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import FilterDriver from '@/components/filters/FilterDriver.vue'
import {Role} from '@/enums/Role'
import Motorista from '@/model/resource/Motorista'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import ModalMotoristaEdit from '@/components/modals/ModalEditMotorista.vue'
import DriverRequest from '@/model/request/DriverRequest'
import ModalSimple from '@/components/modals/ModalSimple.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import * as Helper from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.manage.driverTranshipmentList.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, ModalSimple, FilterDriver, ModalMotoristaEdit},
})
export default class ManageDriverTranshipmentListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/role') role!: Role
  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig
  pushByName = pushByName

  filter = new DriverRequest()

  collection = new PageCollection(Motorista, this.filter, 10)
  motoristaToEdit: Motorista | null = null

  async persistMotoristaTranshipment() {
    const {motoristaToEdit} = this
    if (motoristaToEdit) {
      await motoristaToEdit.persistMotoristaTransbordo()
      const index = this.collection.items.findIndex((item) => item.$id === motoristaToEdit.$id)
      this.collection.items[index] = motoristaToEdit
      this.motoristaToEdit = null
      Helper.success('system.success.persist')
    }
  }
}
